import Component from './TwitterPost.vue'
export default Component
